import React from 'react'
import QRCode from 'react-qr-code';
import { imageBaseUrl } from '../../config/http';

const SuratToko = ({ detailPenjualan, isOpen, isTertunda }) => {
    function numberWithCommas(x) {
        if (x === null || x === undefined || x === '') return '0';
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const tanggal = isTertunda
        ? (detailPenjualan?.tanggal_surat ? String(detailPenjualan.tanggal_surat).split(' ')[0] : '')
        : (detailPenjualan?.created_at
            ? String(detailPenjualan.created_at).split(' ')[0]
            : (detailPenjualan?.tanggal ? String(detailPenjualan.tanggal).split(' ')[0] : ''));

    const getImageUrl = () => {
        const g = detailPenjualan?.item?.gambar1;
        if (!g) return '';
        if (Array.isArray(g)) {
            if (g.length === 0) return '';
            if (typeof g[0] === 'object' && g[0] !== null) {
                return g[0].asli ? `${imageBaseUrl}${g[0].asli}` : '';
            }
            return `${imageBaseUrl}${g[0]}`;
        }
        if (typeof g === 'string') {
            try {
                const parsed = JSON.parse(g);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    if (typeof parsed[0] === 'object' && parsed[0] !== null) {
                        return `${imageBaseUrl}${parsed[0].asli || parsed[0]}`;
                    }
                    return `${imageBaseUrl}${parsed[0]}`;
                }
            } catch {
                return `${imageBaseUrl}${g}`;
            }
        }
        return '';
    };
    const imgSrc = getImageUrl();

    // Normalisasi pembayaran (mendukung split bayar)
    const totalHarga = Number(detailPenjualan?.total_harga) || 0;
    const rawPayments = Array.isArray(detailPenjualan?.payments) && detailPenjualan.payments.length > 0
        ? detailPenjualan.payments
        : [{ metode_pembayaran: detailPenjualan?.metode_pembayaran || 'cash', nominal: totalHarga }];

    const sumMetode = (key) => rawPayments
        .filter((p) => String(p.metode_pembayaran || '').toLowerCase() === key)
        .reduce((acc, p) => acc + (Number(p.nominal) || 0), 0);

    const nominalQris = sumMetode('qris');
    const nominalEdc = sumMetode('edc');
    const nominalTunai = sumMetode('cash') + sumMetode('tunai');
    const nominalTransfer = sumMetode('transfer');

    const paymentParts = [];
    if (nominalQris > 0) paymentParts.push({ label: 'QRIS', nominal: nominalQris });
    if (nominalEdc > 0) paymentParts.push({ label: 'EDC', nominal: nominalEdc });
    if (nominalTunai > 0) paymentParts.push({ label: 'Tunai', nominal: nominalTunai });
    if (nominalTransfer > 0) paymentParts.push({ label: 'Transfer', nominal: nominalTransfer });

    // Berat mata (hanya tampil jika item memiliki nilainya)
    const beratMata = detailPenjualan?.item?.berat_potongan_mata;
    const hasBeratMata = beratMata !== null && beratMata !== undefined && beratMata !== '' && Number(beratMata) > 0;

    return (
        <div className=" ">
            <div className="flex flex-col items-end">
                <div className="mt-[27px] mr-[13px] w-[329px] h-[91px] px-2">
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px] mt-[13px] text-[7px]">
                            <div className=" text-sm">{ detailPenjualan?.created_at_day }</div>
                            {/* <div className=" text-sm">{isOpen ? tanggal : ''}</div> */}
                        </div>
                    </div>
                    {/* <div className="flex justify-end mt-[21px]">
                        <div className="w-[191px] h-[13px]  text-[12px]">ali / 087750999553</div>
                    </div> */}
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px] mt-[5px] text-[7px]">
                            <div className="text-sm">{detailPenjualan?.nama_pembeli || '-'}</div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px]  text-[12px]">
                            <div className="text-sm">{detailPenjualan?.no_hp || '-'}</div>
                        </div>
                    </div>
                    <div className="flex ml-[85px] mt-[13px]">
                        <div className="w-[132px] h-[13px] text-[13px] font-bold">
                            <div className="text-[15px]">{detailPenjualan?.item?.kode_item || '-'} </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-[40px] ml-[100px] flex">
                <div className="h-[125px]  text-[11px] font-bold p-3">
                    <div>
                        {isOpen && imgSrc ? (
                            <img
                                width={150}
                                height={180}
                                style={{ maxHeight: '260px', maxWidth: '380px' }}
                                src={imgSrc}
                                alt=""
                            />
                        ) : (
                            <div className="ml-[20px] w-[120px] h-[120px] mb-2"></div>
                        )}
                    </div>
                </div>
                <div className="h-[102px] mt-[23px]   w-[224px] text-[11px] font-bold p-3">
                    <h2 className="font-semibold text-sm ">
                        {detailPenjualan?.item?.jenis_kategori?.nama_jenis || detailPenjualan?.jenis_kategori?.nama_jenis || '-'}
                    </h2>
                    {hasBeratMata && <h2 className="font-semibold text-sm ">Berat Mata</h2>}
                </div>
                <div className="h-[102px] mt-[23px]   w-[86px] text-[11px] font-bold pt-3 ">
                    <h2 className="font-semibold text-sm">{detailPenjualan?.item?.berat ?? '-'}</h2>
                    {hasBeratMata && <h2 className="font-semibold text-sm">{beratMata}</h2>}
                </div>
                <div className="h-[102px] mt-[23px]   w-[64px] text-[11px] font-bold p-3">
                    <h2 className="font-semibold whitespace-nowrap text-sm">{detailPenjualan?.item?.karat ?? '-'}</h2>
                </div>
                <div className="h-[102px] mt-[23px]   w-[108px] text-[11px] font-bold pl-5 pt-3">
                    <div className="">
                        <QRCode value={detailPenjualan?.kode_trx || 'unknown'} size={60} />
                        <span className="text-[8px] text-center">{detailPenjualan?.kode_trx || '-'}</span>
                    </div>
                </div>
                <div>
                    <div className="h-[102px] mt-[23px]   w-[155px] text-[11px] p-3">
                        <h2 className="font-semibold text-sm ml-[3px] whitespace-nowrap">
                            Rp{numberWithCommas(detailPenjualan?.total_harga ?? 0)}
                        </h2>
                        <div className="mt-2 space-y-1">
                            {paymentParts.map((p) => (
                                <div key={p.label} className="flex justify-between items-center gap-2 whitespace-nowrap">
                                    <span className="text-xs text-[8px]">{p.label}</span>
                                    <span className="text-xs text-[8px]">Rp{numberWithCommas(p.nominal).replace(/,/g, '.')}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-[100px] flex flex-col items-end px-5">
                <div className="flex flex-col items-end">
                   <div className="flex justify-end">
                        <div className="w-[160px] mt-[20px] text-[10px]">
                            <div className="text-xs">{ detailPenjualan?.created_at }</div>
                            {/* <div className=" text-sm">{isOpen ? tanggal : ''}</div> */}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default SuratToko